module.exports = __webpack_public_path__ + "img/coach-avatar.05a070cc.png";